import Vue from 'vue'
import Router from 'vue-router'
// import { Message } from 'element-ui'
// import { get } from '../assets/js/cookie'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

const vueRouter = new Router({
  mode: 'history',
  fallback: false,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/estudy',
      name: 'layout',
      component: () => import('../components/layout.vue'),
      redirect: '/estudy/home',
      alias: '/',
      children: [
        {
          path: 'home',
          name: 'home',
          component: () => import('../views/home')
        },
        {
          path: 'courselist',
          name: 'courseList',
          // redirect: '/list/courseCenter',
          component: () => import('../views/courseList')
          // children: [
          //   {
          //     path: '/list/courseCenter',
          //     name: 'courseCenter',
          //     component: () => import('../views/courseList/courseCenter')
          //   }
          // ]
        },
        {
          path: 'classcourselist',
          name: 'classCourseList',
          component: () => import('../views/courseList/classCourseList')
        },
        {
          path: 'otherlist',
          name: 'otherList',
          component: () => import('../views/courseList/otherList')
        },
        {
          path: 'otherdetail',
          name: 'otherDetail',
          component: () => import('../views/detail/otherDetail')
        },
        {
          path: 'parentallicenselist',
          name: 'parentalLicenseList',
          component: () => import('../views/parentalLicense')
        },
        {
          path: 'parentallicenseresourcedetail',
          name: 'parentalLicenseResourceDetail',
          component: () =>
            import('../views/parentalLicense/detail/resourceDetail')
        },
        {
          path: 'parentallicensevideodetail',
          name: 'parentalLicenseVideoDetail',
          component: () => import('../views/parentalLicense/detail/videoDetail')
        },
        {
          path: 'parentallicensevideo',
          name: 'parentalLicenseVideo',
          component: () =>
            import('../views/parentalLicense/detail/videoDetail/video')
        },
        {
          path: 'teacherlist',
          name: 'teacherList',
          component: () => import('../views/teacher/list')
        },
        {
          path: 'teacherdetail',
          name: 'teacherDetail',
          component: () => import('../views/teacher/detail')
        },
        {
          path: 'coursedetail',
          name: 'courseDetail',
          component: () => import('../views/detail/courseDetail')
        },
        {
          path: 'classdetail',
          name: 'classDetail',
          component: () => import('../views/detail/classDetail')
        },
        {
          path: 'resourcedetail',
          name: 'resourceDetail',
          component: () => import('../views/detail/resourceDetail')
        },
        {
          path: 'advisorydetail',
          name: 'advisoryDetail',
          component: () => import('../views/detail/advisoryDetail')
        },
        {
          path: 'videodetail',
          name: 'videoDetail',
          component: () => import('../views/detail/videoDetail')
        },
        {
          path: 'personalcenter',
          name: 'personalCenter',
          redirect: '/estudy/personalcenter/score',
          component: () => import('../views/personalCenter'),
          children: [
            {
              path: 'score',
              name: 'score',
              component: () => import('../views/personalCenter/score')
            },
            {
              path: 'course',
              name: 'course',
              component: () => import('../views/personalCenter/course')
            },
            {
              path: 'starlicense',
              name: 'starLicense',
              component: () => import('../views/personalCenter/starLicense')
            }
          ]
        }
      ]
    }
  ]
})

export default vueRouter



// WEBPACK FOOTER //
// ./src/router/index.js